/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.SalesOrder {

    import fld = SalesOrderItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class SalesOrderItemsEditor extends _Ext.ItemGridEditor<SalesOrderItemsRow> {
        protected getColumnsKey() { return "SalesOrder.SalesOrderItems"; }
        protected getDialogType() { return SalesOrderItemsDialog; }
        protected getLocalTextPrefix() { return SalesOrderItemsRow.localTextPrefix; }

        protected form: SalesOrderItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }


        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;

        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number; 
        public TotalItems: number; 
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as SalesOrderDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            });

            this.slickGrid.onRender.subscribe(() => {
                // call of the function that will bind the editors with the fields (<input>) of the html page
                this.SetInlineLookupEditor();
            });

        }
          
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            var date = ctx => this.dateInputFormatter(ctx);
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.WstPer).format = num;
            Q.first(columns, x => x.field === fld.Pieces).format = int;

            Q.first(columns, x => x.field === fld.DeliveryDate).format = date;

            //var DeliveryDate = Q.first(columns, x => x.field === fld.DeliveryDate);
            //DeliveryDate.referencedFields = [fld.DeliveryDate];
            //DeliveryDate.format = ctx => {
            //    var width = (ctx.column.width) as number - 10;
            //    return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="DeliveryDate' + ctx.row + '" title="DeliveryDate" />';
            //};


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion
        setMasterValues() {
            this.RateListId = (this.parentDialog as SalesOrderDialog).RateListId;
            this.LaborListId = (this.parentDialog as SalesOrderDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as SalesOrderDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as SalesOrderDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as SalesOrderDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as SalesOrderDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as SalesOrderDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as SalesOrderDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as SalesOrderDialog).form.PartyId.value);
        }
        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        private InlineLookup(RowIndex: string, Items: SalesOrderItemsRow[]) {

            var select = $("#DeliveryDate" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {
                var Editor = new Serenity.DateEditor($("#DeliveryDate" + RowIndex));
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }

                Editor.value = Q.parseDate(Items[RowIndex].DeliveryDate);
                Editor.changeSelect2(e => {
                    Items[RowIndex].DeliveryDate = Q.parseDate(Editor.value);
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeClass('readonly');
                }
            }
        }

        private dateInputFormatter(ctx) {
            var klass = 'edit s-DateEditor';
            var item = ctx.item as SalesOrderItemsRow;
            var pending = this.pendingChanges[item.DeliveryDate];
            var column = ctx.column as Slick.Column;

            if (pending && pending[column.field] !== undefined) {
                klass += ' dirty';
            }

            var value;
            if (item[column.field] == null)
                value = item[column.field];
            else
                value = Q.parseDate(item[column.field]).toLocaleDateString();

            return "<input type='text' class='" + klass +
                "' data-field='" + column.field +
                "' value='" + value +//+ todayDate +
                "' maxlength='" + column.sourceItem.maxLength + "' />" +
                "<script>$('.s-DateEditor').datepicker();</script>";
        }


        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            SalesOrderDialog.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {
                        if (item.TransItemId > 0) {

                            // **** Validate StockId from Stock Transactions ****
                            let StockID;
                            Stock.StockItemService.GetStockTransactions({
                                Line_No: item.Line_No,
                                RefTransId: item.TransId,
                                ProductId: item.ProductId,
                                Take: 1
                            },
                                response => StockID = response.Entities,
                                {
                                    async: false
                                });

                            //Q.alert
                            if (StockID.length > 0) {
                                Q.alert("This Item is used in other transactions, Can Not Delete!!");
                                return;
                            }
                            else {
                                SalesOrder.SalesOrderItemsService.Delete({ EntityId: item.TransItemId });
                                StockID.foreach(function (value) {
                                    Stock.StockItemService.Delete({ EntityId: value.StockId });

                                });

                                var id = this.id(item);
                                this.TotalItems = this.view.getItems().length - 1;
                                this.view.deleteItem(id);
                                this.element.trigger('dialogclose');
                            }
                        }
                        else {
                            var id = this.id(item);
                            this.TotalItems = this.view.getItems().length - 1;
                            this.view.deleteItem(id);
                            this.element.trigger('dialogclose');
                        }

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            this.element.trigger('dialogclose');


            let returnvalue: string = "";
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons.filter(x => x.cssClass == "add-button")[0].visible = false;
            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            buttons.push({
                title: "New Product",
                cssClass: "add-button",
                hotkey: "alt+n",
                hint: 'alt+n',
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null || isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {

                        addbutton.onClick();
                    }

                }
            });
            buttons = buttons.filter(x => x.cssClass != "add-button");
            var grid = Common.ProductSelectGrid;

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                onClick: () => {
                    this.setMasterValues();

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId) || this.PartyId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesOrderGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, 0);
                        this.setData(ItemDetails);

                    }
                    pickerDialog.dialogOpen();
                }
            });
            buttons.push({
                title: "Select Quotation",
                cssClass: "add-button",
                hotkey: "Alt + K",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId) || this.PartyId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    } else {

                        //OMS.ProductSelectGrid.ItemType = 1;

                        var grid = Sales.SalesQuotationItemSelectGrid;
                        var filters: _Ext.SelectGridFilters = {
                            InStock: false,
                            PartyId: this.PartyId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesOrderGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, 0);
                        this.setData(ItemDetails);
                    }

                    pickerDialog.element.bind('dialogclose', () => {

                        this.element.trigger('dialogclose');

                    });
                    pickerDialog.dialogOpen();

                }
            });

            return buttons;
        }

        // #region Set Data

        setData(ItemDetails: any[]) {
            if (this.view.getItems().length > 0) {
                this.TotalItems = ItemDetails.length + this.view.getItems().length;
            }
            else {
                this.TotalItems = ItemDetails.length;
            }
            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion


        // #endregion

    }
}